import React, { Fragment, useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import { SITENAMEALIAS, LOGO, ASSETS } from "../utils/init";

import { Link } from "react-router-dom";
import {
  showToast,
  showHttpError,
  currentPageAccess,
  handleCurrencyDetiails,
} from "../utils/library";
import {
  FetchMerchantStatus,
  FetchPerDayTotalBTCTracsaction,
  FetchUsdBtcLedgerAmount,
  FetchPerDaySuccessUnsuccessTransacCount,
  FetchTotalAverageSale,
  FetchMerchantKeyMetrics,
  FetchMerchantRevenueOverTime,
  FetchMerchantTransactionHealth,
  FetchMerchantPaymentSourcePerformance,
  FetchMerchantTopProducts,
  FetchMerchantTxnSizeDistribution,
  FetchMerchantGeographicDistribution,
  FetchMerchantFailureTxnSummary,
  FetchMerchantSettlementOverview,
  FetchMerchantReports,
} from "../utils/service";
import * as XLSX from "xlsx";
import BtcLogo from "../assets/images/currency/BTC.svg";
import EthLogo from "../assets/images/currency/ETH.svg";
import LtcLogo from "../assets/images/currency/LTC.svg";
import btcLogo from "../assets/images/currency/BTC.svg";
import BchLogo from "../assets/images/currency/BCH.svg";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line, Bar, Doughnut } from "react-chartjs-2";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import {
  ipgeolocation,
  paybitoLogin,
  paybitoSignUp,
  transferBalencetoPaybito,
  ResendOTP,
  CheckOTP,
} from "../utils/service";
import uuid from "react-uuid";
import {
  isBrowser,
  isMobile,
  browserName,
  browserVersion,
} from "react-device-detect";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import qs from "qs";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

/* ─── Static chart color tokens (theme-independent) ─────────────────── */
const T = {
  accent: "#3fb950",
  accentBlue: "#58a6ff",
  accentAmber: "#d29922",
  accentRed: "#f85149",
  accentPurple: "#bc8cff",
  accentCyan: "#39c5cf",
  textMuted: "#8b949e",
  textPrimary: "#e6edf3",
  textSecondary: "#8b949e",
  border: "#21262d",
  borderLight: "#30363d",
  surface: "#161b22",
  surfaceAlt: "#1c2430",
};

/* ══════════════════════════════════════════════════════════════════════
   CUSTOM DATE RANGE PICKER
   ══════════════════════════════════════════════════════════════════════ */
const CAL_MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const CAL_DAYS = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];

const _parseCalDate = (str) => {
  if (!str) return null;
  const d = new Date(str);
  return isNaN(d.getTime())
    ? null
    : new Date(d.getFullYear(), d.getMonth(), d.getDate());
};
const _sameDay = (a, b) => a && b && a.toDateString() === b.toDateString();
const _inRange = (d, s, e) => d && s && e && d > s && d < e;
const _isBefore = (a, b) => a && b && a < b && !_sameDay(a, b);
const _fmtDisp = (d) =>
  d
    ? d.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      })
    : null;

const NAV_BTN_STYLE = {
  background: "none",
  border: "none",
  color: "var(--ins-text-2)",
  cursor: "pointer",
  fontSize: 20,
  lineHeight: 1,
  padding: "2px 8px",
  borderRadius: 6,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "background .15s, color .15s",
};

const CustomDateRangePicker = ({ startDate, endDate, onChange, disabled }) => {
  const startParsed = _parseCalDate(startDate);
  const endParsed = _parseCalDate(endDate);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const [open, setOpen] = React.useState(false);
  const [pendingStart, setPendingStart] = React.useState(null);
  const [hoverDate, setHoverDate] = React.useState(null);
  const [leftMonth, setLeftMonth] = React.useState(() => {
    const base = startParsed || today;
    return new Date(base.getFullYear(), base.getMonth() - 1, 1);
  });

  const rightMonth = new Date(
    leftMonth.getFullYear(),
    leftMonth.getMonth() + 1,
    1
  );
  const wrapRef = React.useRef(null);

  /* close on outside click */
  React.useEffect(() => {
    if (!open) return;
    const fn = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
        setPendingStart(null);
        setHoverDate(null);
      }
    };
    document.addEventListener("mousedown", fn);
    return () => document.removeEventListener("mousedown", fn);
  }, [open]);

  const prevMonth = () =>
    setLeftMonth((m) => new Date(m.getFullYear(), m.getMonth() - 1, 1));
  const nextMonth = () =>
    setLeftMonth((m) => new Date(m.getFullYear(), m.getMonth() + 1, 1));

  const handleDayClick = (date) => {
    if (disabled) return;
    if (!pendingStart) {
      setPendingStart(date);
    } else {
      if (_sameDay(date, pendingStart)) {
        setPendingStart(null);
        return;
      }
      const [s, e] = _isBefore(date, pendingStart)
        ? [date, pendingStart]
        : [pendingStart, date];
      onChange(s, e);
      setPendingStart(null);
      setHoverDate(null);
      setOpen(false);
    }
  };

  /* resolve live range for hover preview */
  const rS = pendingStart || startParsed;
  const rE = pendingStart ? hoverDate : endParsed;
  const [rangeS, rangeE] = rS && rE && _isBefore(rE, rS) ? [rE, rS] : [rS, rE];

  const renderMonth = (monthDate, isLeft) => {
    const yr = monthDate.getFullYear(),
      mo = monthDate.getMonth();
    const firstDow = new Date(yr, mo, 1).getDay();
    const daysInMo = new Date(yr, mo + 1, 0).getDate();
    const cells = [
      ...Array(firstDow).fill(null),
      ...Array.from({ length: daysInMo }, (_, i) => new Date(yr, mo, i + 1)),
    ];

    return (
      <div style={{ flex: 1, minWidth: 220 }}>
        {/* Month header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 16,
          }}
        >
          {isLeft ? (
            <button
              style={NAV_BTN_STYLE}
              onClick={prevMonth}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "var(--ins-border)";
                e.currentTarget.style.color = "var(--ins-text-1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "none";
                e.currentTarget.style.color = "var(--ins-text-2)";
              }}
            >
              ‹
            </button>
          ) : (
            <span style={{ width: 36 }} />
          )}

          <span
            style={{
              fontFamily: "'Syne', sans-serif",
              fontSize: 13,
              fontWeight: 700,
              color: "var(--ins-text-1)",
              letterSpacing: "-0.2px",
            }}
          >
            {CAL_MONTHS[mo]} {yr}
          </span>

          {!isLeft ? (
            <button
              style={NAV_BTN_STYLE}
              onClick={nextMonth}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "var(--ins-border)";
                e.currentTarget.style.color = "var(--ins-text-1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "none";
                e.currentTarget.style.color = "var(--ins-text-2)";
              }}
            >
              ›
            </button>
          ) : (
            <span style={{ width: 36 }} />
          )}
        </div>

        {/* Day-of-week row */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(7,1fr)",
            marginBottom: 4,
          }}
        >
          {CAL_DAYS.map((d) => (
            <div
              key={d}
              style={{
                textAlign: "center",
                fontSize: 10,
                fontWeight: 700,
                letterSpacing: 0.8,
                color: "var(--ins-text-muted)",
                fontFamily: "'JetBrains Mono',monospace",
                padding: "4px 0",
              }}
            >
              {d}
            </div>
          ))}
        </div>

        {/* Day cells */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(7,1fr)",
            rowGap: 1,
          }}
        >
          {cells.map((date, idx) => {
            if (!date) return <div key={`_${idx}`} />;

            const isStart = _sameDay(date, rangeS);
            const isEnd = _sameDay(date, rangeE);
            const isPending = _sameDay(date, pendingStart);
            const inRng = _inRange(date, rangeS, rangeE);
            const isToday = _sameDay(date, today);
            const isCapped = isStart || isEnd || isPending;

            return (
              <div
                key={date.getTime()}
                onClick={() => handleDayClick(date)}
                onMouseEnter={() => {
                  if (pendingStart) setHoverDate(date);
                }}
                onMouseLeave={() => {
                  if (pendingStart) setHoverDate(null);
                }}
                style={{
                  textAlign: "center",
                  cursor: disabled ? "default" : "pointer",
                  padding: "7px 0",
                  fontSize: 12,
                  fontFamily: "'JetBrains Mono', monospace",
                  fontWeight: isCapped ? 700 : isToday ? 600 : 400,
                  color: isCapped
                    ? "#fff"
                    : inRng
                    ? "var(--ins-accent)"
                    : "var(--ins-text-1)",
                  background: isCapped
                    ? "var(--ins-accent)"
                    : inRng
                    ? "rgba(63,185,80,0.12)"
                    : "transparent",
                  borderRadius: isCapped ? "50%" : inRng ? 0 : 6,
                  position: "relative",
                  userSelect: "none",
                  transition: "background .1s, color .1s",
                  outline:
                    isToday && !isCapped
                      ? "1px solid rgba(63,185,80,0.45)"
                      : "none",
                  outlineOffset: -2,
                }}
              >
                {date.getDate()}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  /* Trigger button label */
  const hasRange = startParsed && endParsed;
  const triggerLabel = pendingStart
    ? `${_fmtDisp(pendingStart)} → ?`
    : hasRange
    ? `${_fmtDisp(startParsed)}  —  ${_fmtDisp(endParsed)}`
    : "Select date range";

  return (
    <div
      ref={wrapRef}
      style={{ position: "relative", display: "inline-block" }}
    >
      {/* ── Trigger ── */}
      <button
        onClick={() => !disabled && setOpen((o) => !o)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          background: open ? "var(--ins-surface-alt)" : "var(--ins-surface)",
          border: `1px solid ${
            open ? "var(--ins-accent)" : "var(--ins-border)"
          }`,
          borderRadius: 9,
          padding: "7px 13px",
          fontFamily: "'Syne', sans-serif",
          fontSize: 12.5,
          fontWeight: 600,
          color: hasRange ? "var(--ins-text-1)" : "var(--ins-text-2)",
          cursor: disabled ? "default" : "pointer",
          transition: "border-color .2s, background .2s",
          whiteSpace: "nowrap",
          opacity: disabled ? 0.5 : 1,
        }}
      >
        {/* calendar icon */}
        <svg
          width="13"
          height="13"
          viewBox="0 0 16 16"
          fill="none"
          style={{ flexShrink: 0, opacity: 0.65 }}
        >
          <rect
            x="1"
            y="2"
            width="14"
            height="13"
            rx="2"
            stroke="currentColor"
            strokeWidth="1.4"
          />
          <path
            d="M5 1v2M11 1v2"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
          />
          <path d="M1 6h14" stroke="currentColor" strokeWidth="1.2" />
          <circle cx="5" cy="10" r="1" fill="currentColor" />
          <circle cx="8" cy="10" r="1" fill="currentColor" />
          <circle cx="11" cy="10" r="1" fill="currentColor" />
        </svg>
        <span>{triggerLabel}</span>
        {/* chevron */}
        <svg
          width="9"
          height="9"
          viewBox="0 0 10 10"
          fill="none"
          style={{
            marginLeft: 2,
            opacity: 0.5,
            transition: "transform .2s",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
          }}
        >
          <path
            d="M2 3.5L5 6.5L8 3.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {/* ── Dropdown calendar ── */}
      {open && (
        <div
          style={{
            position: "fixed",
            top: "auto",
            zIndex: 99999,
            background: "var(--ins-surface)",
            border: "1px solid var(--ins-border)",
            borderRadius: 14,
            padding: "20px 20px 16px",
            boxShadow:
              "0 16px 48px rgba(0,0,0,0.4), 0 4px 16px rgba(0,0,0,0.2)",
            minWidth: 500,
            marginTop: 6,
            /* position relative to trigger via JS approach — use CSS top trick */
          }}
          ref={(el) => {
            if (!el) return;
            const trigger = wrapRef.current?.querySelector("button");
            if (!trigger) return;
            const rect = trigger.getBoundingClientRect();
            el.style.top = `${rect.bottom + window.scrollY + 6}px`;
            el.style.left = `${Math.min(
              rect.left + window.scrollX,
              window.innerWidth - 520
            )}px`;
          }}
        >
          {/* Hint text */}
          <div
            style={{
              marginBottom: 14,
              fontSize: 11,
              color: "var(--ins-text-muted)",
              fontFamily: "'Syne', sans-serif",
              fontWeight: 600,
              letterSpacing: 0.4,
            }}
          >
            {pendingStart
              ? `✦ Pick end date  (started ${_fmtDisp(pendingStart)})`
              : "✦ Click a start date"}
          </div>

          {/* Two-month grid */}
          <div style={{ display: "flex", gap: 24, alignItems: "flex-start" }}>
            {renderMonth(leftMonth, true)}
            <div
              style={{
                width: 1,
                background: "var(--ins-border)",
                alignSelf: "stretch",
                margin: "0 4px",
              }}
            />
            {renderMonth(rightMonth, false)}
          </div>

          {/* Footer */}
          <div
            style={{
              marginTop: 14,
              paddingTop: 12,
              borderTop: "1px solid var(--ins-border)",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 10,
            }}
          >
            <span
              style={{
                fontSize: 11,
                color: "var(--ins-text-muted)",
                fontFamily: "'JetBrains Mono',monospace",
              }}
            >
              {hasRange && !pendingStart
                ? `${_fmtDisp(startParsed)}  →  ${_fmtDisp(endParsed)}`
                : "No range selected"}
            </span>
            <div style={{ display: "flex", gap: 8 }}>
              <button
                onClick={() => {
                  setPendingStart(null);
                  setHoverDate(null);
                  setOpen(false);
                }}
                style={{
                  background: "transparent",
                  border: "1px solid var(--ins-border)",
                  borderRadius: 7,
                  padding: "6px 14px",
                  fontSize: 12,
                  fontWeight: 600,
                  fontFamily: "'Syne',sans-serif",
                  color: "var(--ins-text-2)",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
/* ══════════════════════════════════════════════════════════════════════ */

/* ─── CSS with full light/dark variable system ───────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=JetBrains+Mono:wght@400;500;600&display=swap');

  /* ── Theme colors from global index.css variables ── */
  .ins-root {
    --ins-bg:          var(--body-color);
    --ins-surface:     var(--body-color-less);
    --ins-surface-alt: var(--body-color-less2);
    --ins-border:      var(--body-color-less2);
    --ins-border-lt:   var(--body-color-less3);
    --ins-text-1:      var(--text-color);
    --ins-text-2:      var(--text-color);
    --ins-text-muted:  var(--text-color);
    --ins-accent:      var(--btn-color);
    --ins-accent-red:  #f85149;
    --ins-toggle-active-bg: var(--body-color-less);
  }

  .ins-root { background:var(--ins-bg); min-height:100vh; font-family:'Syne',sans-serif; color:var(--ins-text-1); padding:28px 32px 48px; transition:background .3s,color .3s; }
  .ins-root * { box-sizing:border-box; }

  /* Header */
  .ins-header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    position: sticky; top: 0; z-index: 200;
    background: var(--ins-bg);
    margin: -28px -32px 28px 0;
    padding-bottom: 14px;
    padding-right: 32px;
    border-bottom: 1px solid var(--ins-border);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    transition: background .3s, border-color .3s;
    width: calc(100% + 32px);
  }
  .ins-header-left { flex-shrink: 0; min-width: 0; }
  .ins-header-left h1 { font-size:22px; font-weight:800; margin:0 0 2px; letter-spacing:-0.5px; color:var(--ins-text-1); }
  .ins-header-left p  { font-size:12px; color:var(--ins-text-2); margin:0; }
  .ins-header::after {
    content: '';
    position: absolute; bottom: -1px; left: 0; right: 0; height: 1px;
    background: linear-gradient(90deg, transparent, var(--ins-border), transparent);
  }
  .ins-header-left h1 { font-size:28px; font-weight:800; margin:0 0 4px; letter-spacing:-0.5px; color:var(--ins-text-1); }
  .ins-header-left p  { font-size:13px; color:var(--ins-text-2); margin:0; }
  .ins-header-controls { display:flex; align-items:center; gap:10px; flex-wrap:wrap; }
  .ins-export-btn { background:var(--ins-accent); color:#fff; border:none; border-radius:8px; padding:8px 16px; font-size:13px; font-weight:700; font-family:'Syne',sans-serif; cursor:pointer; display:flex; align-items:center; gap:6px; transition:opacity .15s; }
  .ins-export-btn:hover { opacity:.85; }

  /* Section label */
  .ins-section-label { font-size:11px; font-weight:700; letter-spacing:1.5px; text-transform:uppercase; color:var(--ins-text-muted); margin-bottom:12px; display:flex; align-items:center; gap:8px; }
  .ins-section-label::after { content:''; flex:1; height:1px; background:var(--ins-border); }

  /* KPI grid */
  .ins-kpi-grid { display:grid; grid-template-columns:repeat(6,1fr); gap:14px; margin-bottom:28px; }
  @media(max-width:1400px){ .ins-kpi-grid { grid-template-columns:repeat(3,1fr); } }
  @media(max-width:768px){  .ins-kpi-grid { grid-template-columns:repeat(2,1fr); } }

  .ins-kpi-card { background:var(--ins-surface); border:1px solid var(--ins-border); border-radius:14px; padding:20px 20px 16px; position:relative; overflow:hidden; transition:border-color .2s,transform .2s,background .3s; }
  .ins-kpi-card:hover { border-color:var(--ins-border-lt); transform:translateY(-2px); }
  .ins-kpi-card::before { content:''; position:absolute; top:0; left:0; right:0; height:2px; background:var(--kpi-accent); }
  .ins-kpi-label { font-size:11px; color:var(--ins-text-2); text-transform:uppercase; letter-spacing:.8px; font-weight:600; margin-bottom:10px; }
  .ins-kpi-value { font-family:'JetBrains Mono',monospace; font-size:24px; font-weight:600; line-height:1; margin-bottom:8px; color:var(--ins-text-1); }
  .ins-kpi-badge { display:inline-flex; align-items:center; gap:3px; font-size:11px; font-weight:600; padding:2px 7px; border-radius:20px; background:rgba(63,185,80,.12); color:var(--ins-accent); }
  .ins-kpi-badge.down { background:rgba(248,81,73,.12); color:var(--ins-accent-red); }
  .ins-kpi-icon { position:absolute; top:18px; right:18px; font-size:20px; opacity:.22; }

  /* KPI shimmer skeleton */
  @keyframes ins-shimmer { 0%{background-position:-400px 0} 100%{background-position:400px 0} }
  .ins-kpi-skeleton {
    background: var(--ins-surface); border: 1px solid var(--ins-border); border-radius:14px;
    padding:20px 20px 16px; min-height: 96px;
  }
  .ins-shimmer-line {
    border-radius:6px; margin-bottom:10px;
    background: linear-gradient(90deg, var(--ins-border) 25%, var(--ins-surface-alt) 50%, var(--ins-border) 75%);
    background-size: 400px 100%;
    animation: ins-shimmer 1.4s infinite linear;
  }

  /* Card */
  .ins-card { background:var(--ins-surface); border:1px solid var(--ins-border); border-radius:14px; padding:24px; margin-bottom:20px; transition:background .3s,border-color .3s; }
  .ins-card-header { display:flex; align-items:center; justify-content:space-between; margin-bottom:20px; flex-wrap:wrap; gap:12px; }
  .ins-card-title { font-size:15px; font-weight:700; margin:0; color:var(--ins-text-1); }
  .ins-card-sub   { font-size:12px; color:var(--ins-text-2); margin:2px 0 0; }

  /* Toggle pills */
  .ins-toggle-group { display:flex; background:var(--ins-surface-alt); border:1px solid var(--ins-border); border-radius:8px; padding:3px; gap:2px; }
  .ins-toggle-pill  { padding:5px 12px; border-radius:6px; font-size:12px; font-weight:600; cursor:pointer; border:none; background:transparent; color:var(--ins-text-2); font-family:'Syne',sans-serif; transition:all .15s; }
  .ins-toggle-pill.active { background:var(--ins-toggle-active-bg); color:var(--ins-text-1); border:1px solid var(--ins-border); }

  /* Two-col */
  .ins-two-col { display:grid; grid-template-columns:1fr 1fr; gap:20px; margin-bottom:20px; }
  @media(max-width:900px){ .ins-two-col { grid-template-columns:1fr; } }

  /* ── Table ── */
  .ins-table-wrap { overflow-x:auto; overflow-y:hidden; -webkit-overflow-scrolling:touch; }
  .ins-table { width:100%; border-collapse:collapse; font-size:13px; min-width: 600px; }
  .ins-table thead th {
    text-align:left; font-size:11px; font-weight:700; letter-spacing:.8px;
    text-transform:uppercase; color:var(--ins-text-muted);
    padding:12px 18px 12px; border-bottom:1px solid var(--ins-border);
    background:var(--ins-surface-alt);
  }
  .ins-table thead th:first-child { padding-left:20px; }
  .ins-table thead th:last-child  { padding-right:20px; }
  .ins-table tbody tr { border-bottom:1px solid var(--ins-border); transition:background .1s; }
  .ins-table tbody tr:last-child { border-bottom:none; }
  .ins-table tbody tr:hover { background:var(--ins-surface-alt); }
  .ins-table tbody td { padding:15px 18px; color:var(--ins-text-2); vertical-align:middle; }
  .ins-table tbody td:first-child { padding-left:20px; color:var(--ins-text-1); font-weight:600; }
  .ins-table tbody td:last-child  { padding-right:20px; }
  .ins-table .mono { font-family:'JetBrains Mono',monospace; font-size:13px; }

  /* Empty state */
  .ins-empty-state {
    text-align: center; padding: 40px 20px;
    color: var(--ins-text-muted); font-size: 13px;
  }
  .ins-empty-state-icon { font-size: 32px; margin-bottom: 10px; opacity: 0.5; }

  /* Table skeleton rows */
  .ins-table-skeleton td { padding: 15px 18px; }

  /* Dot */
  .ins-dot { display:inline-block; width:8px; height:8px; border-radius:50%; margin-right:7px; }

  /* Progress bar */
  .ins-bar-track { height:4px; background:var(--ins-border); border-radius:4px; overflow:hidden; margin-top:6px; }
  .ins-bar-fill  { height:100%; border-radius:4px; background:var(--fill-color); transition:width .4s ease; }

  /* Settlement */
  .ins-settle-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:14px; }
  @media(max-width:768px){ .ins-settle-grid { grid-template-columns:1fr; } }
  .ins-settle-card   { background:var(--ins-surface-alt); border:1px solid var(--ins-border); border-radius:10px; padding:18px 20px; text-align:center; }
  .ins-settle-label  { font-size:11px; color:var(--ins-text-2); letter-spacing:.6px; text-transform:uppercase; font-weight:600; margin-bottom:8px; }
  .ins-settle-value  { font-family:'JetBrains Mono',monospace; font-size:22px; font-weight:600; color:var(--ins-text-1); }

  /* Download buttons */
  .ins-dl-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:12px; }
  @media(max-width:900px){ .ins-dl-grid { grid-template-columns:repeat(2,1fr); } }
  .ins-dl-btn { background:var(--ins-surface-alt); border:1px solid var(--ins-border); border-radius:10px; padding:16px; text-align:center; cursor:pointer; transition:border-color .15s,background .15s; color:var(--ins-text-2); font-size:13px; font-family:'Syne',sans-serif; }
  .ins-dl-btn:hover { border-color:var(--ins-accent); color:var(--ins-accent); background:rgba(63,185,80,.05); }
  .ins-dl-btn-icon { font-size:22px; margin-bottom:8px; }

  /* Legend */
  .ins-legend { display:flex; gap:16px; flex-wrap:wrap; margin-top:12px; }
  .ins-legend-item { display:flex; align-items:center; gap:6px; font-size:12px; color:var(--ins-text-2); }
  .ins-legend-dot  { width:10px; height:10px; border-radius:50%; }

  /* Banners */
  .ins-banner { border-radius:14px; padding:20px 24px; display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:12px; }
  .ins-banner h3 { font-size:14px; font-weight:700; margin:0 0 4px; color:var(--ins-text-1); }
  .ins-banner p  { font-size:12px; color:var(--ins-text-2); margin:0; }
  .ins-banner-val { font-family:'JetBrains Mono',monospace; font-size:28px; font-weight:600; }
  .ins-banner-green  { background:linear-gradient(135deg,rgba(63,185,80,.08),rgba(88,166,255,.08)); border:1px solid rgba(63,185,80,.25); }
  .ins-banner-purple { background:linear-gradient(135deg,rgba(188,140,255,.08),rgba(57,197,207,.08)); border:1px solid rgba(188,140,255,.25); }

  .ins-bar-track { background:var(--ins-border); }

  /* ── Header Controls Bar ── */
  .ins-controls-bar {
    display: flex; align-items: center; justify-content: space-between;
    width: 100%; gap: 10px;
    background: var(--ins-surface); border: 1px solid var(--ins-border);
    border-radius: 10px; padding: 8px 14px;
  }
  .ins-controls-bar-left { display: flex; align-items: center; gap: 8px; }
  .ins-controls-bar-right { display: flex; align-items: center; gap: 8px; }
  .ins-controls-divider { width: 1px; height: 22px; background: var(--ins-border); flex-shrink: 0; margin: 0 4px; }

  /* ── Asset dropdown ── */
  .ins-asset-btn { display: flex; align-items: center; gap: 8px; background: var(--ins-surface-alt); border: 1px solid var(--ins-border); border-radius: 9px; padding: 7px 12px; font-family: 'Syne', sans-serif; font-size: 13px; font-weight: 600; color: var(--ins-text-1); cursor: pointer; transition: all .2s; position: relative; white-space: nowrap; }
  .ins-asset-btn:hover { border-color: var(--ins-accent); }
  .ins-asset-btn img { width: 18px; height: 18px; border-radius: 50%; }
  .ins-asset-chevron { font-size: 9px; color: var(--ins-text-2); margin-left: 2px; transition: transform .2s; }
  .ins-asset-btn.open .ins-asset-chevron { transform: rotate(180deg); }
  .ins-asset-menu { position: absolute; top: calc(100% + 6px); right: 0; z-index: 999; background: var(--ins-surface); border: 1px solid var(--ins-border); border-radius: 12px; padding: 6px; min-width: 180px; box-shadow: 0 8px 32px rgba(0,0,0,0.25); animation: ins-drop .18s ease; }
  @keyframes ins-drop { from { opacity:0; transform:translateY(-6px); } to { opacity:1; transform:translateY(0); } }
  .ins-asset-option { display: flex; align-items: center; gap: 10px; padding: 9px 12px; border-radius: 8px; cursor: pointer; font-size: 13px; font-weight: 600; color: var(--ins-text-1); transition: background .13s; }
  .ins-asset-option:hover { background: var(--ins-surface-alt); }
  .ins-asset-option img { width: 20px; height: 20px; border-radius: 50%; }
  .ins-asset-option-code { font-family: 'JetBrains Mono', monospace; font-size: 12px; color: var(--ins-text-2); margin-left: auto; }
  .ins-asset-wrap { position: relative; }

  /* ── Selects ── */
  .ins-dropdown { position: relative; display: inline-block; }
  .ins-select { background: var(--ins-surface-alt); border: 1px solid var(--ins-border); border-radius: 8px; padding: 8px 32px 8px 16px; font-family: 'Syne', sans-serif; font-size: 13px; font-weight: 600; color: var(--ins-text-1); cursor: pointer; appearance: none; background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%238b949e' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'/></svg>"); background-repeat: no-repeat; background-position: right 12px center; min-width: 120px; transition: border-color 0.2s; }
  .ins-select:hover { border-color: var(--ins-accent); }
  .ins-select:focus { outline: none; border-color: var(--ins-accent); box-shadow: 0 0 0 2px rgba(63, 185, 80, 0.1); }
  .ins-select option { background: var(--ins-surface); color: var(--ins-text-1); }

  /* ── Loading spinner row ── */
  .ins-loading-row { display: flex; align-items: center; justify-content: center; padding: 32px; gap: 12px; color: var(--ins-text-2); font-size: 13px; }

  /* ── Mobile Responsive ── */
  @media (max-width: 991.98px) {
    .ins-root { padding: 16px 12px; }
    .ins-header { padding: 0; margin-bottom: 20px; }
    .ins-title { font-size: 20px; }
    .ins-subtitle { font-size: 12px; }
    .ins-controls { flex-direction: column; gap: 10px; }
    .ins-select { width: 100%; }
    .ins-table-wrap { overflow-x: auto; overflow-y: hidden; -webkit-overflow-scrolling: touch; }
    .ins-table { min-width: 600px; font-size: 12px; }
    .ins-table thead th { padding: 10px 12px; font-size: 10px; }
    .ins-table thead th:first-child { padding-left: 12px; }
    .ins-table thead th:last-child { padding-right: 12px; }
    .ins-table tbody td { padding: 12px 14px; font-size: 12px; }
    .ins-table tbody td:first-child { padding-left: 12px; }
    .ins-table tbody td:last-child { padding-right: 12px; }
    .ins-chart-grid { grid-template-columns: 1fr; gap: 12px; }
  }
  @media (max-width: 576px) {
    .ins-title { font-size: 18px; }
    .ins-select { font-size: 11px; padding: 6px 28px 6px 12px; }
    .ins-table { min-width: 500px; font-size: 11px; }
    .ins-table thead th { padding: 8px 10px; font-size: 9px; }
    .ins-table tbody td { padding: 10px 12px; font-size: 10px; }
  }
`;

/* ─── Static mock data — only for Settlement (not yet on API) ─────── */
const MOCK = {
  settlement: { settled: "$98,230", pending: "$27,200", avgTime: "2.4 hrs" },
};

/* ─── Helpers ───────────────────────────────────────────────────────── */
const toApiDate = (dateStr) => {
  if (!dateStr) return "";
  const [datePart] = dateStr.split(" ");
  const [y, m, d] = datePart.split("-");
  return `${String(d).padStart(2, "0")}/${String(m).padStart(2, "0")}/${y}`;
};

const formatTimestamp = (timestamp) => {
  if (!timestamp) return "";
  const date = new Date(timestamp);
  return date.toLocaleDateString("en-US", { month: "short", year: "numeric" });
};

const fmtUSD = (val) => {
  if (val == null || isNaN(val)) return "—";
  return (
    "$" +
    Number(val).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  );
};

const fmtCount = (val) => {
  if (val == null || isNaN(val)) return "—";
  return Number(val).toLocaleString("en-US");
};

const fmtPct = (val) => {
  if (val == null || isNaN(val)) return "—";
  return Number(val).toFixed(2) + "%";
};

const fmtPaymentType = (str) => {
  if (!str) return "—";
  return str.replace(/_/g, " ");
};

/* ─── Chart option factories ────────────────────────────────────────── */
const mkLineOpts = (theme) => ({
  responsive: true,
  maintainAspectRatio: true,
  interaction: { mode: "index", intersect: false },
  scales: {
    x: {
      grid: { display: false },
      ticks: {
        color: theme === "light" ? "#4b5563" : "#8b949e",
        font: { family: "'JetBrains Mono'", size: 11 },
      },
      border: { color: theme === "light" ? "#d1d5db" : "#21262d" },
    },
    y: {
      grid: { color: theme === "light" ? "#d1d5db" : "#21262d" },
      ticks: {
        color: theme === "light" ? "#4b5563" : "#8b949e",
        font: { family: "'JetBrains Mono'", size: 11 },
        callback: (v) => "$" + v.toLocaleString(),
      },
      border: { color: theme === "light" ? "#d1d5db" : "#21262d" },
    },
  },
  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: theme === "light" ? "#ffffff" : "#161b22",
      borderColor: theme === "light" ? "#9ca3af" : "#30363d",
      borderWidth: 1,
      titleColor: theme === "light" ? "#0f1117" : "#e6edf3",
      bodyColor: theme === "light" ? "#4b5563" : "#8b949e",
      callbacks: {
        label: (ctx) => {
          let l = ctx.dataset.label || "";
          if (l) l += ": ";
          if (ctx.parsed.y !== null)
            l +=
              "$" +
              ctx.parsed.y.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              });
          return l;
        },
      },
    },
  },
});

const mkBarOpts = (theme) => ({
  responsive: true,
  maintainAspectRatio: true,
  scales: {
    x: {
      grid: { display: false },
      ticks: {
        color: theme === "light" ? "#4b5563" : "#8b949e",
        font: { family: "'JetBrains Mono'", size: 11 },
      },
      border: { color: theme === "light" ? "#d1d5db" : "#21262d" },
    },
    y: {
      grid: { color: theme === "light" ? "#d1d5db" : "#21262d" },
      ticks: {
        color: theme === "light" ? "#4b5563" : "#8b949e",
        font: { family: "'JetBrains Mono'", size: 11 },
        callback: (v) => v.toLocaleString(),
      },
      border: { color: theme === "light" ? "#d1d5db" : "#21262d" },
    },
  },
  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: theme === "light" ? "#ffffff" : "#161b22",
      borderColor: theme === "light" ? "#9ca3af" : "#30363d",
      borderWidth: 1,
      titleColor: theme === "light" ? "#0f1117" : "#e6edf3",
      bodyColor: theme === "light" ? "#4b5563" : "#8b949e",
    },
  },
});

const mkDoughnutOpts = (theme) => ({
  responsive: true,
  cutout: "68%",
  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: theme === "light" ? "#ffffff" : "#161b22",
      borderColor: theme === "light" ? "#9ca3af" : "#30363d",
      borderWidth: 1,
      titleColor: theme === "light" ? "#0f1117" : "#e6edf3",
      bodyColor: theme === "light" ? "#4b5563" : "#8b949e",
    },
  },
});

/* ─── Tiny presentational helpers ───────────────────────────────────── */
const SectionLabel = ({ children }) => (
  <div className="ins-section-label">{children}</div>
);

const KpiCard = ({
  label,
  value,
  badge,
  badgeDown,
  icon,
  accentColor,
  loading,
}) => {
  if (loading) {
    return (
      <div className="ins-kpi-skeleton">
        <div
          className="ins-shimmer-line"
          style={{ height: 10, width: "55%" }}
        />
        <div
          className="ins-shimmer-line"
          style={{ height: 26, width: "75%" }}
        />
        <div
          className="ins-shimmer-line"
          style={{ height: 16, width: "40%", marginBottom: 0 }}
        />
      </div>
    );
  }
  return (
    <div className="ins-kpi-card" style={{ "--kpi-accent": accentColor }}>
      <div className="ins-kpi-icon">{icon}</div>
      <div className="ins-kpi-label">{label}</div>
      <div className="ins-kpi-value" style={{ color: accentColor }}>
        {value}
      </div>
      {badge && (
        <span className={`ins-kpi-badge${badgeDown ? " down" : ""}`}>
          {badgeDown ? "▼" : "▲"} {badge}
        </span>
      )}
    </div>
  );
};

const TableSkeleton = ({ rows = 4, cols = 4 }) => (
  <tbody>
    {Array.from({ length: rows }).map((_, ri) => (
      <tr key={ri} className="ins-table-skeleton">
        {Array.from({ length: cols }).map((_, ci) => (
          <td key={ci}>
            <div
              className="ins-shimmer-line"
              style={{
                height: 12,
                width: ci === 0 ? "70%" : "50%",
                marginBottom: 0,
              }}
            />
          </td>
        ))}
      </tr>
    ))}
  </tbody>
);

const EmptyState = ({
  message = "No data available for the selected period.",
}) => (
  <div className="ins-empty-state">
    <div className="ins-empty-state-icon">📭</div>
    <div>{message}</div>
  </div>
);

/* ─── Main Class Component ───────────────────────────────────────────── */
class Insights extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddAddressModal: false,
      showLoader: false,
      startDate: "",
      endDate: "",
      assets: [],
      selectedAsset: {},
      totalSalesVolume: "0.00",
      averageSalesAmount: "0.00",
      isPasswordMatched: false,
      showOtpModal: false,
      showWithdrawOptionModal: false,
      transferModal: false,
      paybitoSignUpId: "",
      externalAddress: "",
      amountForTransferToExternalAddress: 0,
      theme: "dark",
      assetMenuOpen: false,
      revenueView: "daily",
      revenueOverlay: "both",

      /* ── Key Metrics ── */
      kpiLoading: false,
      kpi: {
        totalVolume: null,
        totalTxn: null,
        successRate: null,
        avgPayment: null,
        processingFee: null,
        customerFee: null,
      },

      /* ── Revenue Over Time ── */
      revenueLoading: false,
      revenueData: {
        labels: [],
        datasets: [
          {
            id: 1,
            label: "Revenue",
            data: [],
            backgroundColor: T.accent + "22",
            borderColor: T.accent,
            fill: true,
            tension: 0.4,
          },
        ],
      },
      volumeData: {
        labels: [],
        datasets: [
          {
            id: 1,
            label: "Payment Count",
            data: [],
            backgroundColor: T.accentBlue,
            borderColor: T.accentBlue,
            tension: 0.4,
            yAxisID: "y1",
          },
        ],
      },
      feeData: {
        labels: [],
        datasets: [
          {
            id: 1,
            label: "Transaction Fees",
            data: [],
            backgroundColor: T.accentPurple + "22",
            borderColor: T.accentPurple,
            fill: true,
            tension: 0.4,
          },
        ],
      },

      /* ── Transaction Volume Chart ── */
      transactionVolumeData: {
        labels: [],
        datasets: [
          {
            id: 1,
            label: "Successful",
            data: [],
            backgroundColor: T.accentBlue,
            borderColor: T.accentBlue,
            tension: 0.4,
          },
          {
            id: 2,
            label: "Unsuccessful",
            data: [],
            backgroundColor: T.accentRed,
            borderColor: T.accentRed,
            tension: 0.4,
          },
        ],
      },

      /* ── Transaction Health ── */
      healthLoading: false,
      paymentStatusData: { labels: [], values: [], colors: [] },
      paymentMethodData: {
        labels: [],
        values: [],
        colors: [],
        percentages: [],
      },

      /* ── Payment Type Performance ── */
      paymentSourceLoading: false,
      paymentSourceData: [],

      /* ── Top Products ── */
      topProductsLoading: false,
      topProductsData: [],

      /* ── Transaction Size Distribution ── */
      txnSizeLoading: false,
      txnSizeData: [],

      /* ── Geographic Distribution ── */
      geoLoading: false,
      geoData: [],

      /* ── Failure Transaction Summary ── */
      failureLoading: false,
      failureData: [],

      selectionRangeForDateRange: {
        startDate: "",
        endDate: "",
        key: "selection",
      },

      settlementLoading: false,
      settlementData: {
        total_settled: null,
        pending_settlement: null,
        avg_settlement_time: "0",
      },
    };

    this.emailRef = React.createRef();
    this.passwordRef = React.createRef();
    this.AmountRef = React.createRef();
    this.signupPhoneRef = React.createRef();
    this.signupFirstNameRef = React.createRef();
    this.signupLastNameRef = React.createRef();
    this.signupEmailRef = React.createRef();
    this.signupPasswordRef = React.createRef();
    this.signupRePasswordRef = React.createRef();
    this.signupMiddleNameRef = React.createRef();
    this.otpRef = React.createRef();
  }

  /* ─── Build common payload ─────────────────────────────────────────── */
  buildPayload = () => {
    const { startDate, endDate, selectedAsset } = this.state;
    const currency =
      selectedAsset && selectedAsset.assetCode
        ? selectedAsset.assetCode
        : "ALL";
    return {
      merchant_id:
        localStorage.getItem(SITENAMEALIAS + "_merchant_id") || "2589",
      currency,
      start_date: toApiDate(startDate) || "03/11/2025",
      end_date: toApiDate(endDate) || "11/03/2026",
    };
  };

  /* ─── Key Metrics API ──────────────────────────────────────────────── */
  handleRenderKeyMetrics = () => {
    const payload = { ...this.buildPayload(), time_duration: "MONTHLY" };
    this.setState({ kpiLoading: true });
    FetchMerchantKeyMetrics(payload)
      .then((res) => {
        this.setState({ kpiLoading: false });
        const response = res.data[0];
        if (response.error !== "0") {
          showToast(
            "error",
            response.error_msg ||
              response.message ||
              "Failed to load key metrics"
          );
          return;
        }
        this.setState({
          kpi: {
            totalVolume: fmtUSD(response.total_processed_volume),
            totalTxn: fmtCount(response.total_transactions),
            successRate: fmtPct(response.success_rate),
            avgPayment: fmtUSD(response.average_payment_size),
            processingFee: fmtUSD(response.processing_fees_collected),
            customerFee: fmtUSD(response.customer_paid_fees),
          },
        });
      })
      .catch((err) => {
        this.setState({ kpiLoading: false });
        showHttpError(err);
      });
  };

  /* ─── Revenue Over Time API ─────────────────────────────────────────── */
  handleRenderRevenueOverTime = () => {
    const { revenueView } = this.state;
    const timeDurationMap = {
      daily: "DAILY",
      weekly: "WEEKLY",
      monthly: "MONTHLY",
    };
    const payload = {
      ...this.buildPayload(),
      time_duration: timeDurationMap[revenueView] || "MONTHLY",
    };

    this.setState({ revenueLoading: true });
    FetchMerchantRevenueOverTime(payload)
      .then((res) => {
        this.setState({ revenueLoading: false });
        const responseData =
          Array.isArray(res.data) && res.data.length > 0
            ? res.data[0]
            : res.data;
        if (responseData.error !== "0") {
          showToast(
            "error",
            responseData.error_msg ||
              responseData.message ||
              "Failed to load revenue data"
          );
          return;
        }

        if (
          responseData.chart_data &&
          Array.isArray(responseData.chart_data) &&
          responseData.chart_data.length > 0
        ) {
          const sortedData = [...responseData.chart_data].sort(
            (a, b) => new Date(a.time_stamp) - new Date(b.time_stamp)
          );
          const labels = sortedData.map((item) =>
            formatTimestamp(item.time_stamp)
          );
          const revenueValues = sortedData.map(
            (item) => parseFloat(item.vol) || 0
          );
          const paymentCounts = sortedData.map(
            (item) => parseInt(item.payment_count) || 0
          );
          const feeValues = sortedData.map(
            (item) => parseFloat(item.TXN_CHARGE) || 0
          );

          this.setState({
            revenueData: {
              labels,
              datasets: [
                {
                  id: 1,
                  label: "Revenue",
                  data: revenueValues,
                  backgroundColor: T.accent + "22",
                  borderColor: T.accent,
                  fill: true,
                  tension: 0.4,
                },
              ],
            },
            volumeData: {
              labels,
              datasets: [
                {
                  id: 1,
                  label: "Payment Count",
                  data: paymentCounts,
                  backgroundColor: T.accentBlue,
                  borderColor: T.accentBlue,
                  fill: false,
                  tension: 0.4,
                  yAxisID: "y1",
                  type: "line",
                },
              ],
            },
            feeData: {
              labels,
              datasets: [
                {
                  id: 1,
                  label: "Transaction Fees",
                  data: feeValues,
                  backgroundColor: T.accentPurple + "22",
                  borderColor: T.accentPurple,
                  fill: true,
                  tension: 0.4,
                },
              ],
            },
          });
        } else {
          this.setState({
            revenueData: {
              labels: [],
              datasets: [
                {
                  id: 1,
                  label: "Revenue",
                  data: [],
                  backgroundColor: T.accent + "22",
                  borderColor: T.accent,
                  fill: true,
                  tension: 0.4,
                },
              ],
            },
            volumeData: {
              labels: [],
              datasets: [
                {
                  id: 1,
                  label: "Payment Count",
                  data: [],
                  backgroundColor: T.accentBlue,
                  borderColor: T.accentBlue,
                  fill: false,
                  tension: 0.4,
                  yAxisID: "y1",
                  type: "line",
                },
              ],
            },
            feeData: {
              labels: [],
              datasets: [
                {
                  id: 1,
                  label: "Transaction Fees",
                  data: [],
                  backgroundColor: T.accentPurple + "22",
                  borderColor: T.accentPurple,
                  fill: true,
                  tension: 0.4,
                },
              ],
            },
          });
          if (responseData.chart_data && responseData.chart_data.length === 0)
            showToast(
              "info",
              "No revenue data available for the selected period"
            );
        }
      })
      .catch((err) => {
        this.setState({ revenueLoading: false });
        showHttpError(err);
      });
  };

  /* ─── Transaction Health API ─────────────────────────────────────────── */
  handleRenderTransactionHealth = () => {
    const payload = this.buildPayload();
    this.setState({ healthLoading: true });
    FetchMerchantTransactionHealth(payload)
      .then((res) => {
        this.setState({ healthLoading: false });
        const responseData =
          Array.isArray(res.data) && res.data.length > 0
            ? res.data[0]
            : res.data;
        if (responseData.error !== "0") {
          showToast(
            "error",
            responseData.error_msg ||
              responseData.message ||
              "Failed to load transaction health data"
          );
          return;
        }

        const statusColors = {
          SUCCESS_COUNT: T.accent,
          PENDING_COUNT: T.accentAmber,
          EXPIRED_COUNT: T.textMuted,
          FAILED_COUNT: T.accentRed,
        };
        const statusLabels = {
          SUCCESS_COUNT: "Successful",
          PENDING_COUNT: "Pending",
          EXPIRED_COUNT: "Expired",
          FAILED_COUNT: "Failed",
        };

        if (
          responseData.payment_status_breakdown &&
          responseData.payment_status_breakdown.length > 0
        ) {
          const statusData = responseData.payment_status_breakdown[0];
          const labels = [],
            values = [],
            colors = [];
          Object.keys(statusData).forEach((key) => {
            if (key.includes("_COUNT") && parseInt(statusData[key]) > 0) {
              labels.push(statusLabels[key] || key.replace("_COUNT", ""));
              values.push(parseInt(statusData[key]));
              colors.push(statusColors[key] || T.textMuted);
            }
          });
          this.setState({ paymentStatusData: { labels, values, colors } });
        }

        const methodColors = {
          BTC: T.accentAmber,
          ETH: T.accentBlue,
          USDT: T.accent,
          USDC: T.accentCyan,
          BCH: T.accentPurple,
          XRP: T.accentRed,
        };
        if (
          responseData.payment_method_distribution &&
          responseData.payment_method_distribution.length > 0
        ) {
          const mLabels = [],
            mValues = [],
            mColors = [],
            mPct = [];
          responseData.payment_method_distribution.forEach((item) => {
            mLabels.push(item.CURRENCY_CODE);
            mValues.push(parseInt(item.TRANSACTION_COUNT));
            mPct.push(parseFloat(item.PERCENTAGE));
            mColors.push(methodColors[item.CURRENCY_CODE] || T.accentPurple);
          });
          this.setState({
            paymentMethodData: {
              labels: mLabels,
              values: mValues,
              colors: mColors,
              percentages: mPct,
            },
          });
        }
      })
      .catch((err) => {
        this.setState({ healthLoading: false });
        showHttpError(err);
      });
  };

  /* ─── Payment Source Performance API ──────────────────────────────── */
  handleRenderPaymentSourcePerformance = () => {
    const payload = this.buildPayload();
    this.setState({ paymentSourceLoading: true });
    FetchMerchantPaymentSourcePerformance(payload)
      .then((res) => {
        this.setState({ paymentSourceLoading: false });
        const responseData =
          Array.isArray(res.data) && res.data.length > 0
            ? res.data[0]
            : res.data;
        if (responseData.error !== "0") {
          showToast(
            "error",
            responseData.error_msg ||
              responseData.message ||
              "Failed to load payment source performance"
          );
          return;
        }
        this.setState({
          paymentSourceData: responseData.payment_source_data || [],
        });
      })
      .catch((err) => {
        this.setState({ paymentSourceLoading: false });
        showHttpError(err);
      });
  };

  /* ─── Top Products API ──────────────────────────────────────────────── */
  handleRenderTopProducts = () => {
    const payload = this.buildPayload();
    this.setState({ topProductsLoading: true });
    FetchMerchantTopProducts(payload)
      .then((res) => {
        this.setState({ topProductsLoading: false });
        const responseData =
          Array.isArray(res.data) && res.data.length > 0
            ? res.data[0]
            : res.data;
        if (responseData.error !== "0") {
          showToast(
            "error",
            responseData.error_msg ||
              responseData.message ||
              "Failed to load top products"
          );
          return;
        }
        this.setState({
          topProductsData: responseData.top_products_data || [],
        });
      })
      .catch((err) => {
        this.setState({ topProductsLoading: false });
        showHttpError(err);
      });
  };

  /* ─── Transaction Size Distribution API ─────────────────────────────── */
  handleRenderTxnSizeDistribution = () => {
    const payload = this.buildPayload();
    this.setState({ txnSizeLoading: true });
    FetchMerchantTxnSizeDistribution(payload)
      .then((res) => {
        this.setState({ txnSizeLoading: false });
        const responseData =
          Array.isArray(res.data) && res.data.length > 0
            ? res.data[0]
            : res.data;
        if (responseData.error !== "0") {
          showToast(
            "error",
            responseData.error_msg ||
              responseData.message ||
              "Failed to load transaction size distribution"
          );
          return;
        }
        this.setState({
          txnSizeData: responseData.transaction_size_distribution || [],
        });
      })
      .catch((err) => {
        this.setState({ txnSizeLoading: false });
        showHttpError(err);
      });
  };

  /* ─── Geographic Distribution API ────────────────────────────────── */
  handleRenderGeographicDistribution = () => {
    const payload = this.buildPayload();
    this.setState({ geoLoading: true });
    FetchMerchantGeographicDistribution(payload)
      .then((res) => {
        this.setState({ geoLoading: false });
        const responseData =
          Array.isArray(res.data) && res.data.length > 0
            ? res.data[0]
            : res.data;
        if (responseData.error !== "0") {
          showToast(
            "error",
            responseData.error_msg ||
              responseData.message ||
              "Failed to load geographic data"
          );
          return;
        }
        this.setState({ geoData: responseData.geographic_distribution || [] });
      })
      .catch((err) => {
        this.setState({ geoLoading: false });
        showHttpError(err);
      });
  };

  /* ─── Failure Transaction Summary API ─────────────────────────────── */
  handleRenderFailureTxnSummary = () => {
    const payload = this.buildPayload();
    this.setState({ failureLoading: true });
    FetchMerchantFailureTxnSummary(payload)
      .then((res) => {
        this.setState({ failureLoading: false });
        const responseData =
          Array.isArray(res.data) && res.data.length > 0
            ? res.data[0]
            : res.data;
        if (responseData.error !== "0") {
          showToast(
            "error",
            responseData.error_msg ||
              responseData.message ||
              "Failed to load failure data"
          );
          return;
        }
        this.setState({ failureData: responseData.failure_txn_data || [] });
      })
      .catch((err) => {
        this.setState({ failureLoading: false });
        showHttpError(err);
      });
  };

  /* ─── Settlement Overview API ──────────────────────────────────────── */
  handleRenderSettlementOverview = () => {
    const payload = this.buildPayload();
    this.setState({ settlementLoading: true });
    FetchMerchantSettlementOverview(payload)
      .then((res) => {
        this.setState({ settlementLoading: false });
        const responseData =
          Array.isArray(res.data) && res.data.length > 0
            ? res.data[0]
            : res.data;
        if (responseData.error !== "0") {
          showToast(
            "error",
            responseData.error_msg ||
              responseData.message ||
              "Failed to load settlement data"
          );
          return;
        }
        this.setState({
          settlementData: {
            total_settled: responseData.total_settled || 0,
            pending_settlement: responseData.pending_settlement || 0,
            avg_settlement_time: responseData.avg_settlement_time || 0,
          },
        });
      })
      .catch((err) => {
        this.setState({ settlementLoading: false });
        showHttpError(err);
      });
  };

  /* ─── Revenue chart builder ─────────────────────────────────────────── */
  buildRevenueChartData() {
    const { revenueData, volumeData, feeData, revenueOverlay } = this.state;
    const datasets = [];
    if (revenueOverlay === "revenue" || revenueOverlay === "both") {
      datasets.push({
        ...revenueData.datasets[0],
        label: "Revenue ($)",
        borderColor: T.accent,
        backgroundColor: T.accent + "18",
        fill: true,
        tension: 0.4,
        yAxisID: "y",
      });
    }
    if (revenueOverlay === "payments" || revenueOverlay === "both") {
      datasets.push({
        ...volumeData.datasets[0],
        label: "Payment Count",
        borderColor: T.accentBlue,
        backgroundColor: T.accentBlue + "18",
        fill: false,
        tension: 0.4,
        yAxisID: "y1",
        type: "line",
      });
    }
    if (revenueOverlay === "fees" || revenueOverlay === "both") {
      datasets.push({
        ...feeData.datasets[0],
        label: "Transaction Fees ($)",
        borderColor: T.accentPurple,
        backgroundColor: T.accentPurple + "18",
        fill: true,
        tension: 0.4,
        yAxisID: "y",
      });
    }
    return { labels: revenueData.labels, datasets };
  }

  getRevenueChartOptions() {
    const { revenueOverlay, theme } = this.state;
    const baseOpts = {
      responsive: true,
      maintainAspectRatio: true,
      interaction: { mode: "index", intersect: false },
      plugins: {
        legend: { display: false },
        tooltip: {
          backgroundColor: theme === "light" ? "#ffffff" : "#161b22",
          borderColor: theme === "light" ? "#9ca3af" : "#30363d",
          borderWidth: 1,
          titleColor: theme === "light" ? "#0f1117" : "#e6edf3",
          bodyColor: theme === "light" ? "#4b5563" : "#8b949e",
          callbacks: {
            label: (ctx) => {
              let l = ctx.dataset.label || "";
              if (l) l += ": ";
              if (ctx.parsed.y !== null) {
                l += l.includes("Count")
                  ? ctx.parsed.y.toLocaleString()
                  : "$" +
                    ctx.parsed.y.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    });
              }
              return l;
            },
          },
        },
      },
    };
    const xScale = {
      grid: { display: false },
      ticks: {
        color: theme === "light" ? "#4b5563" : "#8b949e",
        font: { family: "'JetBrains Mono'", size: 11 },
        maxRotation: 45,
        minRotation: 45,
      },
      border: { color: theme === "light" ? "#d1d5db" : "#21262d" },
    };
    if (revenueOverlay === "both") {
      return {
        ...baseOpts,
        scales: {
          x: xScale,
          y: {
            type: "linear",
            display: true,
            position: "left",
            grid: { color: theme === "light" ? "#d1d5db" : "#21262d" },
            ticks: {
              color: theme === "light" ? "#4b5563" : "#8b949e",
              font: { family: "'JetBrains Mono'", size: 11 },
              callback: (v) => "$" + v.toLocaleString(),
            },
            title: {
              display: true,
              text: "Revenue / Fees ($)",
              color: theme === "light" ? "#4b5563" : "#8b949e",
            },
          },
          y1: {
            type: "linear",
            display: true,
            position: "right",
            grid: { drawOnChartArea: false },
            ticks: {
              color: T.accentBlue,
              font: { family: "'JetBrains Mono'", size: 11 },
              callback: (v) => v.toLocaleString(),
            },
            title: {
              display: true,
              text: "Payment Count",
              color: T.accentBlue,
            },
          },
        },
      };
    }
    return {
      ...baseOpts,
      scales: {
        x: xScale,
        y: {
          grid: { color: theme === "light" ? "#d1d5db" : "#21262d" },
          ticks: {
            color: theme === "light" ? "#4b5563" : "#8b949e",
            font: { family: "'JetBrains Mono'", size: 11 },
            callback: (v) =>
              revenueOverlay === "payments"
                ? v.toLocaleString()
                : "$" + v.toLocaleString(),
          },
          border: { color: theme === "light" ? "#d1d5db" : "#21262d" },
        },
      },
    };
  }

  getChartColors = () => ({
    primary: T.accent,
    secondary: T.accentBlue,
    tick: T.textMuted,
  });

  handleRenderMerchantOverviewChart = () => {
    this.handleRenderRevenueOverTime();
  };

  handleRenderTxnVolumeChart = () => {
    const payload = {
      end_date: this.state.endDate,
      start_date: this.state.startDate,
      currency_id: this.state.selectedAsset.assetId,
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });
    FetchPerDaySuccessUnsuccessTransacCount(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          const response = res.data;
          const errorObj = response[response.length - 1];
          if (errorObj.error !== "0") {
            showToast("error", errorObj.error_msg);
            return;
          }
          const labels = [],
            dataSuccessful = [],
            dataUnsuccessful = [];
          for (let i = 0; i < response.length - 1; i++) {
            labels.push(response[i].created_date);
            dataSuccessful.push(response[i].success_count);
            dataUnsuccessful.push(response[i].unsuccess_count);
          }
          this.setState({
            transactionVolumeData: {
              labels,
              datasets: [
                {
                  id: 1,
                  label: "Successful",
                  data: dataSuccessful,
                  backgroundColor: T.accentBlue,
                  borderColor: T.accentBlue,
                  tension: 0.4,
                },
                {
                  id: 2,
                  label: "Unsuccessful",
                  data: dataUnsuccessful,
                  backgroundColor: T.accentRed,
                  borderColor: T.accentRed,
                  tension: 0.4,
                },
              ],
            },
          });
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  /* ─── Download Report as Excel ─────────────────────────────────────── */
  handleDownloadReport = (reportType) => {
    const base = this.buildPayload();
    const payload = {
      merchant_id: base.merchant_id,
      currency: base.currency,
      start_date: base.start_date,
      end_date: base.end_date,
      report_type: reportType,
      offset: 0,
      limit: 10,
    };

    this.setState({ showLoader: true });
    FetchMerchantReports(payload)
      .then((res) => {
        this.setState({ showLoader: false });
        const response = res.data;
        const responseData =
          Array.isArray(response) && response.length > 0
            ? response[0]
            : response;

        if (responseData.error !== "0") {
          showToast(
            "error",
            responseData.error_msg ||
              responseData.message ||
              "Failed to fetch report"
          );
          return;
        }
        if (
          !responseData.report_data ||
          responseData.report_data.length === 0
        ) {
          showToast("info", "No data available for this report");
          return;
        }

        const data = responseData.report_data;
        const headerMap = {
          TRANSACTIONS: {
            invoice_id: "Invoice ID",
            invoice_date: "Invoice Date",
            currency: "Currency",
            amount_paid: "Amount Paid",
            amount_paid_home_curr: "Amount (Home Currency)",
            status: "Status",
          },
          FEES: {
            invoice_id: "Invoice ID",
            invoice_date: "Invoice Date",
            currency: "Currency",
            amount_paid: "Amount Paid",
            txn_charge: "Transaction Fee",
            txn_charge_home_curr: "Fee (Home Currency)",
            txn_per: "Fee %",
          },
          REVENUE_SUMMARY: {
            invoice_date: "Date",
            currency: "Currency",
            total_invoices: "Total Invoices",
            total_amount_paid: "Total Amount Paid",
            total_amount_paid_home_curr: "Total (Home Currency)",
          },
          SUBSCRIPTIONS: {
            customer_name: "Customer Name",
            customer_email: "Customer Email",
            currency: "Currency",
            amount: "Amount",
            recurring_period: "Recurring Period",
            total_cycles: "Total Cycles",
            start_date: "Start Date",
            next_billing_date: "Next Billing Date",
            description: "Description",
          },
        };

        const columns = headerMap[reportType] || {};
        const keys = Object.keys(columns);
        const headers = keys.map((k) => columns[k]);
        const rows = data.map((row) => keys.map((k) => row[k] || ""));
        const wsData = [headers, ...rows];
        const ws = XLSX.utils.aoa_to_sheet(wsData);
        ws["!cols"] = headers.map((h, i) => {
          const maxLen = Math.max(
            h.length,
            ...rows.map((r) => String(r[i] || "").length)
          );
          return { wch: Math.min(maxLen + 2, 40) };
        });
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, reportType.replace(/_/g, " "));
        XLSX.writeFile(wb, `${reportType.toLowerCase()}_report.xlsx`);
        showToast("success", "Report downloaded successfully");
      })
      .catch((err) => {
        this.setState({ showLoader: false });
        showHttpError(err);
      });
  };

  /* ─── Centralised "refresh all" helper ─────────────────────────────── */
  refreshAllPanels = () => {
    this.handleRenderKeyMetrics();
    this.handleRenderRevenueOverTime();
    this.handleRenderTransactionHealth();
    this.handleRenderPaymentSourcePerformance();
    this.handleRenderTopProducts();
    this.handleRenderTxnSizeDistribution();
    this.handleRenderGeographicDistribution();
    this.handleRenderFailureTxnSummary();
    this.handleRenderSettlementOverview();
  };

  /* ── date change: refresh all panels ───────────────────────────────── */
  handleOnDateChange = (startDateObj, endDateObj) => {
    const fmt = (d) => `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
    const startDay = fmt(startDateObj) + " 00:00:00";
    const endDay = fmt(endDateObj) + " 23:59:00";
    this.setState(
      {
        startDate: startDay,
        endDate: endDay,
        selectionRangeForDateRange: {
          startDate: startDay,
          endDate: endDay,
          key: "selection",
        },
      },
      () => this.refreshAllPanels()
    );
  };

  handleRenderTotalAverageSale = () => {
    const payload = {
      end_date: this.state.endDate,
      start_date: this.state.startDate,
      currency_id: this.state.selectedAsset.assetId,
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });
    FetchTotalAverageSale(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          const response = res.data[0];
          if (response.error !== "0") {
            showToast("error", response.error_msg);
            return;
          }
          if (
            response.current_sale_amount != undefined &&
            response.current_avg_sale != undefined
          ) {
            this.setState({
              totalSalesVolume: parseFloat(
                response.current_sale_amount
              ).toFixed(2),
              averageSalesAmount: parseFloat(response.current_avg_sale).toFixed(
                2
              ),
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  handleRenderAssets = () => {
    const payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });
    FetchUsdBtcLedgerAmount(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          const response = res.data[0];
          if (response.error !== "0") {
            showToast("error", response.error_msg);
            return;
          }
          if (response && response.coin_balance) {
            const allOption = {
              assetName: "All Currencies",
              assetCode: "ALL",
              assetId: 0,
              assetImage: null,
              network: "",
              isBrokerCurrency: 0,
            };
            const currencyArr = response.coin_balance
              .filter((c) => c.currency_code !== "USD")
              .map((c) => ({
                assetName: c.currency_name,
                coinBalance: c.balance,
                assetCode: c.currency_code,
                assetId: c.currency_id,
                assetImage: c.logo,
                network: c.network,
                isBrokerCurrency: c.is_broker_currency,
              }));
            const arr = [allOption, ...currencyArr];
            this.setState({ assets: arr }, () => {
              localStorage.setItem(
                SITENAMEALIAS + "_assets",
                JSON.stringify(arr)
              );
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  componentDidMount() {
    this.setState({ permission: currentPageAccess() });

    const detectTheme = () => {
      const stored = localStorage.getItem(SITENAMEALIAS + "_theme") || "dark";
      this.setState({ theme: stored === "dark" ? "dark" : "light" });
    };
    detectTheme();
    this._themeObserver = new MutationObserver(detectTheme);
    this._themeObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ["class", "data-theme", "style"],
    });
    this._themeObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class", "data-theme", "style"],
    });
    this._themeInterval = setInterval(detectTheme, 500);
    this._themeTimeout = setTimeout(
      () => clearInterval(this._themeInterval),
      5000
    );

    if (!localStorage.getItem(SITENAMEALIAS + "deviceId"))
      localStorage.setItem(SITENAMEALIAS + "deviceId", uuid());
    localStorage.setItem(
      SITENAMEALIAS + "deviceType",
      isMobile ? "mobile" : "Desktop browser"
    );
    localStorage.setItem(
      SITENAMEALIAS + "browserName",
      `${browserName} ${browserVersion}`
    );
    ipgeolocation().then((res) => {
      localStorage.setItem(SITENAMEALIAS + "latitude", res.data.latitude);
      localStorage.setItem(SITENAMEALIAS + "longitude", res.data.longitude);
      localStorage.setItem(SITENAMEALIAS + "ipaddress", res.data.ip);
      localStorage.setItem(SITENAMEALIAS + "location", res.data.country_name);
    });

    this.handleRenderAssets();

    const now = new Date(),
      y = now.getFullYear(),
      m = now.getMonth(),
      d = now.getDate();
    const fmt = (dt) =>
      `${dt.getFullYear()}-${dt.getMonth() + 1}-${dt.getDate()}`;
    const startDay = fmt(new Date(y, m, d - 15)) + " 00:00:00";
    const endDay = fmt(new Date(y, m, d)) + " 23:59:00";

    const defaultAsset = {
      assetName: "All Currencies",
      assetCode: "ALL",
      assetId: 0,
      assetImage: null,
    };
    this.setState(
      {
        selectedAsset: defaultAsset,
        startDate: startDay,
        endDate: endDay,
        selectionRangeForDateRange: {
          startDate: startDay,
          endDate: endDay,
          key: "selection",
        },
      },
      () => this.refreshAllPanels()
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.revenueView !== this.state.revenueView) {
      this.handleRenderRevenueOverTime();
    }
  }

  componentWillUnmount() {
    if (this._themeObserver) this._themeObserver.disconnect();
    if (this._themeInterval) clearInterval(this._themeInterval);
    if (this._themeTimeout) clearTimeout(this._themeTimeout);
  }

  render() {
    const {
      selectedAsset,
      assets,
      permission,
      theme,
      kpi,
      kpiLoading,
      revenueLoading,
      healthLoading,
      paymentStatusData,
      paymentMethodData,
      paymentSourceLoading,
      paymentSourceData,
      topProductsLoading,
      topProductsData,
      txnSizeLoading,
      txnSizeData,
      geoLoading,
      geoData,
      failureLoading,
      failureData,
      settlementLoading,
      settlementData,
    } = this.state;

    const fmtSettlementUSD = (val) => {
      if (val == null || isNaN(val)) return "—";
      return (
        "$" +
        Number(val).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );
    };

    /* ── Doughnut — Payment Status ── */
    const doughnutData = {
      labels:
        paymentStatusData.labels.length > 0
          ? paymentStatusData.labels
          : ["Successful", "Pending", "Expired", "Failed"],
      datasets: [
        {
          data:
            paymentStatusData.values.length > 0
              ? paymentStatusData.values
              : [1775, 28, 32, 18],
          backgroundColor:
            paymentStatusData.colors.length > 0
              ? paymentStatusData.colors
              : [T.accent, T.accentAmber, T.textMuted, T.accentRed],
          borderColor: T.surface,
          borderWidth: 3,
        },
      ],
    };

    /* ── Bar — Payment Method ── */
    const methodBarData = {
      labels:
        paymentMethodData.labels.length > 0
          ? paymentMethodData.labels
          : ["BTC", "ETH", "USDT", "BCH", "XRP"],
      datasets: [
        {
          label: "Transactions",
          data:
            paymentMethodData.values.length > 0
              ? paymentMethodData.values
              : [520, 380, 640, 210, 92],
          backgroundColor:
            paymentMethodData.colors.length > 0
              ? paymentMethodData.colors
              : [
                  T.accentAmber,
                  T.accentBlue,
                  T.accent,
                  T.accentCyan,
                  T.accentPurple,
                ],
          borderRadius: 6,
          borderSkipped: false,
        },
      ],
    };

    /* ── Bar — Transaction Size Distribution ── */
    const txnSizeChartData = {
      labels: txnSizeData.length > 0 ? txnSizeData.map((d) => d.bucket) : [],
      datasets: [
        {
          label: "Payments",
          data:
            txnSizeData.length > 0
              ? txnSizeData.map((d) => parseInt(d.transaction_count) || 0)
              : [],
          backgroundColor: T.accentBlue + "cc",
          borderRadius: 6,
          borderSkipped: false,
        },
      ],
    };

    const totalPaymentSourceTxn = paymentSourceData.reduce(
      (a, b) => a + (parseInt(b.transaction_count) || 0),
      0
    );

    const maxTopProductRevenue =
      topProductsData.length > 0
        ? Math.max(...topProductsData.map((p) => parseFloat(p.revenue) || 0))
        : 1;

    const maxGeoTxn =
      geoData.length > 0
        ? Math.max(...geoData.map((g) => parseInt(g.transaction_count) || 0))
        : 1;

    const totalFailures = failureData.reduce(
      (a, b) => a + (parseInt(b.transaction_count) || 0),
      0
    );
    const maxFailCount =
      failureData.length > 0
        ? Math.max(
            ...failureData.map((f) => parseInt(f.transaction_count) || 0)
          )
        : 1;

    const typeBarColors = [
      T.accent,
      T.accentBlue,
      T.accentCyan,
      T.accentAmber,
      T.accentPurple,
      T.accentRed,
    ];

    return (
      <Fragment>
        <style>{CSS}</style>
        <div className="container-scroller">
          <Sidebar />
          <Header />
          <div className="main-panel">
            <div className="ins-root" data-theme={theme}>
              {/* ── PAGE HEADER ──────────────────────────────────────── */}
              <div className="ins-header">
                <div className="ins-header-left">
                  <h1>Insights</h1>
                  <p>
                    Analyze payment performance, revenue trends, and transaction
                    activity.
                  </p>
                </div>

                <div className="ins-controls-bar">
                  <div className="ins-controls-bar-left">
                    {/* ── Custom Date Range Picker ── */}
                    <CustomDateRangePicker
                      startDate={this.state.startDate}
                      endDate={this.state.endDate}
                      onChange={(s, e) => {
                        if (permission === "READ") {
                          showToast(
                            "error",
                            "You need write access to perform this operation"
                          );
                          return;
                        }
                        this.handleOnDateChange(s, e);
                      }}
                      disabled={permission === "READ"}
                    />
                  </div>

                  <div className="ins-controls-bar-right">
                    <div className="ins-controls-divider" />

                    {/* Asset selector */}
                    <div className="ins-asset-wrap">
                      <button
                        className={`ins-asset-btn${
                          this.state.assetMenuOpen ? " open" : ""
                        }`}
                        onClick={() =>
                          this.setState((s) => ({
                            assetMenuOpen: !s.assetMenuOpen,
                          }))
                        }
                      >
                        {selectedAsset.assetImage ? (
                          <img src={selectedAsset.assetImage} alt="" />
                        ) : selectedAsset.assetCode === "ALL" ? (
                          <span style={{ fontSize: 18, marginRight: 4 }}>
                            🌐
                          </span>
                        ) : null}
                        {selectedAsset.assetCode || "Asset"}
                        <span className="ins-asset-chevron">▼</span>
                      </button>
                      {this.state.assetMenuOpen && (
                        <div className="ins-asset-menu">
                          {assets.map((item) => (
                            <div
                              key={item.assetId}
                              className="ins-asset-option"
                              onClick={() => {
                                this.setState(
                                  { selectedAsset: item, assetMenuOpen: false },
                                  () => this.refreshAllPanels()
                                );
                              }}
                            >
                              {item.assetImage ? (
                                <img src={item.assetImage} alt="" />
                              ) : item.assetCode === "ALL" ? (
                                <span style={{ fontSize: 20, marginRight: 8 }}>
                                  🌐
                                </span>
                              ) : null}
                              {item.assetName}
                              <span className="ins-asset-option-code">
                                {item.assetCode}
                              </span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    <div className="ins-controls-divider" />
                    <button
                      className="ins-export-btn"
                      disabled={permission === "READ"}
                      style={
                        permission === "READ"
                          ? { opacity: 0.5, cursor: "not-allowed" }
                          : null
                      }
                      onClick={() => {
                        if (permission === "READ") {
                          showToast(
                            "error",
                            "You need write access to perform this operation"
                          );
                          return;
                        }
                        this.handleDownloadReport("TRANSACTIONS");
                      }}
                    >
                      <span style={{ fontSize: 14 }}>↓</span> Export Excel
                    </button>
                  </div>
                </div>
              </div>

              {/* ── SECTION 1 — KPI CARDS ───────────────────────────── */}
              <SectionLabel>Key Metrics</SectionLabel>
              <div className="ins-kpi-grid">
                <KpiCard
                  loading={kpiLoading}
                  label="Total Processed Volume"
                  value={kpi.totalVolume ?? "—"}
                  icon="💰"
                  accentColor={T.accent}
                />
                <KpiCard
                  loading={kpiLoading}
                  label="Total Transactions"
                  value={kpi.totalTxn ?? "—"}
                  icon="🔄"
                  accentColor={T.accentBlue}
                />
                <KpiCard
                  loading={kpiLoading}
                  label="Success Rate"
                  value={kpi.successRate ?? "—"}
                  icon="✅"
                  accentColor={T.accentCyan}
                />
                <KpiCard
                  loading={kpiLoading}
                  label="Average Payment Size"
                  value={kpi.avgPayment ?? "—"}
                  icon="📊"
                  accentColor={T.accentAmber}
                />
                <KpiCard
                  loading={kpiLoading}
                  label="Processing Fees Collected"
                  value={kpi.processingFee ?? "—"}
                  icon="⚙️"
                  accentColor={T.accentPurple}
                />
                <KpiCard
                  loading={kpiLoading}
                  label="Customer Paid Fees"
                  value={kpi.customerFee ?? "—"}
                  icon="👤"
                  accentColor={T.accentRed}
                />
              </div>

              {/* ── SECTION 2 — REVENUE TREND ─────────────────────── */}
              <SectionLabel>Revenue Trend</SectionLabel>
              <div className="ins-card" style={{ marginBottom: 20 }}>
                <div className="ins-card-header">
                  <div>
                    <h3 className="ins-card-title">Revenue Over Time</h3>
                    <p className="ins-card-sub">
                      Track volume and payment count across your selected period
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "12px",
                      alignItems: "center",
                    }}
                  >
                    <div className="ins-dropdown">
                      <select
                        className="ins-select"
                        value={this.state.revenueView}
                        onChange={(e) =>
                          this.setState({ revenueView: e.target.value })
                        }
                      >
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                      </select>
                    </div>
                    <div className="ins-dropdown">
                      <select
                        className="ins-select"
                        value={this.state.revenueOverlay}
                        onChange={(e) =>
                          this.setState({ revenueOverlay: e.target.value })
                        }
                      >
                        <option value="revenue">Revenue</option>
                        <option value="payments">Payments</option>
                        <option value="fees">Fees</option>
                        <option value="both">All</option>
                      </select>
                    </div>
                  </div>
                </div>
                {revenueLoading ? (
                  <div className="ins-loading-row">
                    <div
                      className="spinner-border"
                      role="status"
                      style={{ color: T.accent }}
                    >
                      <span className="sr-only">Loading...</span>
                    </div>
                    <span>Loading revenue data…</span>
                  </div>
                ) : (
                  <Line
                    options={this.getRevenueChartOptions()}
                    data={this.buildRevenueChartData()}
                  />
                )}
                <div className="ins-legend">
                  <div className="ins-legend-item">
                    <div
                      className="ins-legend-dot"
                      style={{ background: T.accent }}
                    />
                    <span>Revenue ($)</span>
                  </div>
                  <div className="ins-legend-item">
                    <div
                      className="ins-legend-dot"
                      style={{ background: T.accentBlue }}
                    />
                    <span>Payment Count</span>
                  </div>
                  <div className="ins-legend-item">
                    <div
                      className="ins-legend-dot"
                      style={{ background: T.accentPurple }}
                    />
                    <span>Transaction Fees ($)</span>
                  </div>
                </div>
              </div>

              {/* ── SECTION 3 — TRANSACTION HEALTH ─────────────────── */}
              <SectionLabel>Transaction Health</SectionLabel>
              <div className="ins-two-col">
                <div className="ins-card">
                  <div className="ins-card-header">
                    <div>
                      <h3 className="ins-card-title">
                        Payment Status Breakdown
                      </h3>
                      <p className="ins-card-sub">
                        Distribution of all transaction outcomes
                      </p>
                    </div>
                  </div>
                  {healthLoading ? (
                    <div className="ins-loading-row">
                      <div
                        className="spinner-border"
                        role="status"
                        style={{ color: T.accent }}
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div style={{ maxWidth: 260, margin: "0 auto" }}>
                        <Doughnut
                          options={mkDoughnutOpts(theme)}
                          data={doughnutData}
                        />
                      </div>
                      <div
                        className="ins-legend"
                        style={{ marginTop: 20, justifyContent: "center" }}
                      >
                        {doughnutData.labels.map((l, i) => (
                          <div key={l} className="ins-legend-item">
                            <div
                              className="ins-legend-dot"
                              style={{
                                background:
                                  doughnutData.datasets[0].backgroundColor[i],
                              }}
                            />
                            <span>
                              {l} ({doughnutData.datasets[0].data[i]})
                            </span>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>
                <div className="ins-card">
                  <div className="ins-card-header">
                    <div>
                      <h3 className="ins-card-title">
                        Payment Method Distribution
                      </h3>
                      <p className="ins-card-sub">
                        Which crypto customers actually pay with
                      </p>
                    </div>
                  </div>
                  {healthLoading ? (
                    <div className="ins-loading-row">
                      <div
                        className="spinner-border"
                        role="status"
                        style={{ color: T.accent }}
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <Bar options={mkBarOpts(theme)} data={methodBarData} />
                  )}
                  {paymentMethodData.percentages.length > 0 && (
                    <div
                      className="ins-legend"
                      style={{ marginTop: 10, justifyContent: "center" }}
                    >
                      {paymentMethodData.labels.map((l, i) => (
                        <div key={l} className="ins-legend-item">
                          <div
                            className="ins-legend-dot"
                            style={{ background: paymentMethodData.colors[i] }}
                          />
                          <span>
                            {l} ({paymentMethodData.percentages[i]}%)
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* ── SECTION 4 — PAYMENT TYPE PERFORMANCE ─────────────── */}
              <SectionLabel>Payment Type Performance</SectionLabel>
              <div className="ins-card">
                <div className="ins-card-header">
                  <div>
                    <h3 className="ins-card-title">Payment Type Performance</h3>
                    <p className="ins-card-sub">
                      Which payment sources are driving revenue
                    </p>
                  </div>
                  {!paymentSourceLoading && paymentSourceData.length > 0 && (
                    <span
                      style={{
                        fontFamily: "'JetBrains Mono'",
                        fontSize: 12,
                        color: T.textMuted,
                      }}
                    >
                      {totalPaymentSourceTxn} total transactions
                    </span>
                  )}
                </div>
                <div className="ins-table-wrap">
                  <table className="ins-table">
                    <thead>
                      <tr>
                        <th>Payment Type</th>
                        <th>Transactions</th>
                        <th>Revenue</th>
                        <th>Share</th>
                      </tr>
                    </thead>
                    {paymentSourceLoading ? (
                      <TableSkeleton rows={3} cols={4} />
                    ) : paymentSourceData.length === 0 ? (
                      <tbody>
                        <tr>
                          <td colSpan={4}>
                            <EmptyState message="No payment type data available for the selected period." />
                          </td>
                        </tr>
                      </tbody>
                    ) : (
                      <tbody>
                        {paymentSourceData.map((row, i) => {
                          const txnCount = parseInt(row.transaction_count) || 0;
                          const sharePct =
                            totalPaymentSourceTxn > 0
                              ? Math.round(
                                  (txnCount / totalPaymentSourceTxn) * 100
                                )
                              : 0;
                          return (
                            <tr key={row.payment_type}>
                              <td>{fmtPaymentType(row.payment_type)}</td>
                              <td className="mono">
                                {fmtCount(row.transaction_count)}
                              </td>
                              <td className="mono" style={{ color: T.accent }}>
                                {fmtUSD(row.revenue)}
                              </td>
                              <td style={{ width: 180 }}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 10,
                                  }}
                                >
                                  <div
                                    className="ins-bar-track"
                                    style={{ flex: 1 }}
                                  >
                                    <div
                                      className="ins-bar-fill"
                                      style={{
                                        width: `${sharePct}%`,
                                        "--fill-color":
                                          typeBarColors[
                                            i % typeBarColors.length
                                          ],
                                      }}
                                    />
                                  </div>
                                  <span
                                    style={{
                                      fontFamily: "'JetBrains Mono'",
                                      fontSize: 11,
                                      color: T.textMuted,
                                      minWidth: 30,
                                    }}
                                  >
                                    {sharePct}%
                                  </span>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    )}
                  </table>
                </div>
              </div>

              {/* ── SECTION 5 — TOP PRODUCTS ─────────────────────────── */}
              <SectionLabel>Top Products</SectionLabel>
              <div className="ins-card">
                <div className="ins-card-header">
                  <div>
                    <h3 className="ins-card-title">
                      Top Payment Links / Products
                    </h3>
                    <p className="ins-card-sub">
                      Your best-performing offerings by revenue
                    </p>
                  </div>
                  {!topProductsLoading && topProductsData.length > 0 && (
                    <span
                      style={{
                        fontFamily: "'JetBrains Mono'",
                        fontSize: 12,
                        color: T.textMuted,
                      }}
                    >
                      {topProductsData.length} product
                      {topProductsData.length !== 1 ? "s" : ""}
                    </span>
                  )}
                </div>
                <div className="ins-table-wrap">
                  <table className="ins-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Product / Description</th>
                        <th>Transactions</th>
                        <th>Revenue</th>
                        {/* <th>Revenue Share</th> */}
                      </tr>
                    </thead>
                    {topProductsLoading ? (
                      <TableSkeleton rows={4} cols={5} />
                    ) : topProductsData.length === 0 ? (
                      <tbody>
                        <tr>
                          <td colSpan={5}>
                            <EmptyState message="No product data available for the selected period." />
                          </td>
                        </tr>
                      </tbody>
                    ) : (
                      <tbody>
                        {topProductsData.map((row, i) => {
                          const rev = parseFloat(row.revenue) || 0;
                          const barWidth =
                            maxTopProductRevenue > 0
                              ? Math.round((rev / maxTopProductRevenue) * 100)
                              : 0;
                          return (
                            <tr key={i}>
                              <td
                                style={{
                                  color: T.textMuted,
                                  width: 32,
                                  fontFamily: "'JetBrains Mono'",
                                }}
                              >
                                {i + 1}
                              </td>
                              <td style={{ maxWidth: 300 }}>
                                <div
                                  style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {row.product_description || "—"}
                                </div>
                              </td>
                              <td className="mono">
                                {fmtCount(row.transaction_count)}
                              </td>
                              <td className="mono" style={{ color: T.accent }}>
                                {fmtUSD(row.revenue)}
                              </td>
                              {/* <td style={{ width: 160 }}>
                                <div className="ins-bar-track">
                                  <div className="ins-bar-fill" style={{ width: `${barWidth}%`, "--fill-color": typeBarColors[i % typeBarColors.length] }} />
                                </div>
                              </td> */}
                            </tr>
                          );
                        })}
                      </tbody>
                    )}
                  </table>
                </div>
              </div>

              {/* ── SECTION 6 + 7 — DISTRIBUTION + GEOGRAPHY ─────────── */}
              <SectionLabel>Distribution &amp; Geography</SectionLabel>
              <div className="ins-two-col">
                <div className="ins-card">
                  <div className="ins-card-header">
                    <div>
                      <h3 className="ins-card-title">
                        Transaction Size Distribution
                      </h3>
                      <p className="ins-card-sub">
                        Customer spending behaviour by payment size
                      </p>
                    </div>
                  </div>
                  {txnSizeLoading ? (
                    <div className="ins-loading-row">
                      <div
                        className="spinner-border"
                        role="status"
                        style={{ color: T.accent }}
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                      <span>Loading distribution data…</span>
                    </div>
                  ) : txnSizeData.length === 0 ? (
                    <EmptyState message="No transaction size data available for the selected period." />
                  ) : (
                    <Bar options={mkBarOpts(theme)} data={txnSizeChartData} />
                  )}
                </div>

                <div className="ins-card">
                  <div className="ins-card-header">
                    <div>
                      <h3 className="ins-card-title">Top Countries Paying</h3>
                      <p className="ins-card-sub">
                        Geographic distribution of transactions
                      </p>
                    </div>
                    {!geoLoading && geoData.length > 0 && (
                      <span
                        style={{
                          fontFamily: "'JetBrains Mono'",
                          fontSize: 12,
                          color: T.textMuted,
                        }}
                      >
                        {geoData.length} countr
                        {geoData.length !== 1 ? "ies" : "y"}
                      </span>
                    )}
                  </div>
                  {geoLoading ? (
                    <div className="ins-loading-row">
                      <div
                        className="spinner-border"
                        role="status"
                        style={{ color: T.accent }}
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                      <span>Loading geographic data…</span>
                    </div>
                  ) : geoData.length === 0 ? (
                    <EmptyState message="No geographic data available for the selected period." />
                  ) : (
                    geoData.map((g, i) => {
                      const txnCount = parseInt(g.transaction_count) || 0;
                      const barPct =
                        maxGeoTxn > 0 ? (txnCount / maxGeoTxn) * 100 : 0;
                      return (
                        <div key={g.country || i} style={{ marginBottom: 14 }}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginBottom: 4,
                              fontSize: 13,
                            }}
                          >
                            <span style={{ color: "var(--ins-text-1)" }}>
                              {g.country}
                            </span>
                            <span
                              style={{
                                fontFamily: "'JetBrains Mono'",
                                color: "var(--ins-text-2)",
                              }}
                            >
                              {fmtCount(txnCount)}
                            </span>
                          </div>
                          <div className="ins-bar-track">
                            <div
                              className="ins-bar-fill"
                              style={{
                                width: `${barPct}%`,
                                "--fill-color":
                                  typeBarColors[i % typeBarColors.length],
                              }}
                            />
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>

              {/* ── SECTION 8 — FAILURE ANALYSIS ─────────────────────── */}
              <SectionLabel>Failure Analysis</SectionLabel>
              <div className="ins-card">
                <div className="ins-card-header">
                  <div>
                    <h3 className="ins-card-title">Payment Failures</h3>
                    <p className="ins-card-sub">
                      Understand what's causing checkout drop-offs
                    </p>
                  </div>
                  {!failureLoading && failureData.length > 0 && (
                    <span
                      style={{
                        fontFamily: "'JetBrains Mono'",
                        fontSize: 13,
                        color: T.accentRed,
                      }}
                    >
                      {fmtCount(totalFailures)} total failures
                    </span>
                  )}
                </div>
                <div className="ins-table-wrap">
                  <table className="ins-table">
                    <thead>
                      <tr>
                        <th>Reason</th>
                        <th>Count</th>
                        <th>Visual</th>
                      </tr>
                    </thead>
                    {failureLoading ? (
                      <TableSkeleton rows={3} cols={3} />
                    ) : failureData.length === 0 ? (
                      <tbody>
                        <tr>
                          <td colSpan={3}>
                            <EmptyState message="No failure data available for the selected period." />
                          </td>
                        </tr>
                      </tbody>
                    ) : (
                      <tbody>
                        {failureData.map((r, i) => {
                          const count = parseInt(r.transaction_count) || 0;
                          const barPct =
                            maxFailCount > 0 ? (count / maxFailCount) * 100 : 0;
                          return (
                            <tr key={r.reason || i}>
                              <td>
                                <span
                                  className="ins-dot"
                                  style={{ background: T.accentRed }}
                                />
                                {r.reason}
                              </td>
                              <td
                                className="mono"
                                style={{ color: T.accentRed }}
                              >
                                {fmtCount(count)}
                              </td>
                              <td style={{ width: 160 }}>
                                <div className="ins-bar-track">
                                  <div
                                    className="ins-bar-fill"
                                    style={{
                                      width: `${barPct}%`,
                                      "--fill-color": T.accentRed,
                                    }}
                                  />
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    )}
                  </table>
                </div>
              </div>

              {/* ── SECTION 9 — SETTLEMENT ───────────────────────────── */}
              <SectionLabel>Settlement Overview</SectionLabel>
              <div className="ins-card">
                <div className="ins-card-header">
                  <div>
                    <h3 className="ins-card-title">Settlement Summary</h3>
                    <p className="ins-card-sub">
                      Finance team overview of funds movement
                    </p>
                  </div>
                  {settlementLoading && (
                    <div
                      className="spinner-border spinner-border-sm"
                      role="status"
                      style={{ color: T.accent }}
                    >
                      <span className="sr-only">Loading...</span>
                    </div>
                  )}
                </div>
                {settlementLoading ? (
                  <div className="ins-settle-grid">
                    {[1, 2, 3].map((i) => (
                      <div key={i} className="ins-settle-card">
                        <div
                          className="ins-shimmer-line"
                          style={{ height: 10, width: "60%", marginBottom: 8 }}
                        />
                        <div
                          className="ins-shimmer-line"
                          style={{ height: 22, width: "40%", marginBottom: 0 }}
                        />
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="ins-settle-grid">
                    <div className="ins-settle-card">
                      <div className="ins-settle-label">Total Settled</div>
                      <div
                        className="ins-settle-value"
                        style={{ color: T.accent }}
                      >
                        {fmtSettlementUSD(settlementData.total_settled)}
                      </div>
                    </div>
                    <div className="ins-settle-card">
                      <div className="ins-settle-label">Pending Settlement</div>
                      <div
                        className="ins-settle-value"
                        style={{ color: T.accentAmber }}
                      >
                        {fmtSettlementUSD(settlementData.pending_settlement)}
                      </div>
                    </div>
                    <div className="ins-settle-card">
                      <div className="ins-settle-label">
                        Avg Settlement Time
                      </div>
                      <div
                        className="ins-settle-value"
                        style={{ color: T.accentBlue }}
                      >
                        {settlementData.avg_settlement_time}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* ── SECTION 10 — DOWNLOAD REPORTS ─────────────────────── */}
              <SectionLabel>Download Reports</SectionLabel>
              <div className="ins-card">
                <div className="ins-card-header">
                  <div>
                    <h3 className="ins-card-title">Downloadable Reports</h3>
                    <p className="ins-card-sub">
                      Export your data for accounting and analysis
                    </p>
                  </div>
                </div>
                <div className="ins-dl-grid">
                  {[
                    {
                      icon: "📋",
                      label: "Export Transactions",
                      type: "TRANSACTIONS",
                    },
                    { icon: "💸", label: "Export Fees", type: "FEES" },
                    {
                      icon: "📈",
                      label: "Export Revenue Summary",
                      type: "REVENUE_SUMMARY",
                    },
                    {
                      icon: "🔁",
                      label: "Export Subscriptions",
                      type: "SUBSCRIPTIONS",
                    },
                  ].map((b) => (
                    <button
                      key={b.label}
                      className="ins-dl-btn"
                      disabled={permission === "READ"}
                      style={
                        permission === "READ"
                          ? { opacity: 0.5, cursor: "not-allowed" }
                          : null
                      }
                      onClick={() => {
                        if (permission === "READ") {
                          showToast(
                            "error",
                            "You need write access to perform this operation"
                          );
                          return;
                        }
                        this.handleDownloadReport(b.type);
                      }}
                    >
                      <div className="ins-dl-btn-icon">{b.icon}</div>
                      {b.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
            {/* /ins-root */}
            <Footer />
          </div>
          {/* /main-panel */}

          <Loader show={this.state.showLoader} />
        </div>
      </Fragment>
    );
  }
}

export default Insights;
